// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const accordionWrapper = document.querySelectorAll('.accordionWrapper')
if (accordionWrapper && accordionWrapper !== null) {
  accordionWrapper.forEach((wrapper) => {
    import('./Accordion/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const mobileMenuWrapper = document.querySelectorAll('.mobileMenuWrapper')
if (mobileMenuWrapper && mobileMenuWrapper !== null) {
  mobileMenuWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const menuButtonWrapper = document.querySelectorAll('.menuButtonWrapper')
if (menuButtonWrapper && menuButtonWrapper !== null) {
  menuButtonWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const newsArchiveWrapper = document.querySelectorAll('.newsArchiveWrapper')
if (newsArchiveWrapper && newsArchiveWrapper !== null) {
  newsArchiveWrapper.forEach((wrapper) => {
    import('./NewsArchive/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const newsletterWrapper = document.getElementById('newsletter')
if (newsletterWrapper && newsletterWrapper !== null) {
  import('./Newsletter/index.ts')
    .then((module) => {
      module.default(newsletterWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const contactFormWrapper = document.getElementById('contact-form')
if (contactFormWrapper && contactFormWrapper !== null) {
  import('./ContactForm/index.ts')
    .then((module) => {
      module.default(contactFormWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const identifyFormWrapper = document.getElementById('identify-form')
if (identifyFormWrapper && identifyFormWrapper !== null) {
  import('./ContactFormIdentify/index.ts')
    .then((module) => {
      module.default(identifyFormWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const interviewsArchiveWrapper = document.querySelectorAll('.interviewsArchiveWrapper')
if (interviewsArchiveWrapper && interviewsArchiveWrapper !== null) {
  interviewsArchiveWrapper.forEach((wrapper) => {
    import('./InterviewsArchive/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const searchButtonWrapper = document.querySelector('.js-search-button')
if (searchButtonWrapper && searchButtonWrapper !== null) {
  import('./SearchBar/index.ts')
    .then((module) => {
      module.default()
    })
    .catch((err) => {
      console.log(err)
    })
}

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const menu = document.getElementById('menu')
const subMenu = document.getElementById('subMenu')

if (menu && subMenu) {
  menu.addEventListener('click', () => {
    const isHidden = subMenu.classList.toggle('hidden')
    menu.classList.toggle('open')
    menu.setAttribute('aria-expanded', (!isHidden).toString())
  })
}

const menuItems = document.querySelectorAll<HTMLLIElement>('.menu-item-has-children')

menuItems.forEach((menuItem) => {
  const parentLink = menuItem.querySelector<HTMLAnchorElement>('a')

  if (parentLink) {
    parentLink.addEventListener('click', (event) => {
      event.preventDefault()

      const subMenu = menuItem.querySelector<HTMLUListElement>('.sub-menu')
      if (!subMenu) return

      const isOpen = menuItem.classList.contains('open')

      const parentUL = menuItem.parentElement

      if (parentUL && parentUL.classList.contains('main-menu')) {
        const siblingItems = Array.from(parentUL.children).filter(
          (el) => el !== menuItem && el.classList.contains('menu-item-has-children')
        )

        siblingItems.forEach((sibling) => {
          sibling.classList.remove('open')
          const siblingSubMenu = sibling.querySelector<HTMLUListElement>('.sub-menu')
          if (siblingSubMenu) siblingSubMenu.style.display = 'none'
          sibling.setAttribute('aria-expanded', 'false')
        })
      }

      menuItem.classList.toggle('open', !isOpen)
      subMenu.style.display = isOpen ? 'none' : 'block'
      menuItem.setAttribute('aria-expanded', (!isOpen).toString())
    })
  }
})
